import { render, staticRenderFns } from "./LbaMenu.vue?vue&type=template&id=7be7c15e"
import script from "./LbaMenu.vue?vue&type=script&lang=js"
export * from "./LbaMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports